<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
    <path d="M18 11H62.6667V69H18V11Z" stroke="#00529A" stroke-width="2"/>
    <path d="M43.9913 33.1391L34.5 38.7476V34V33H33.5H29V19H53V33H44.5H44.2266L43.9913 33.1391Z" stroke="#00529A" stroke-width="2"/>
    <path d="M28.0526 46.3158H53.6667" stroke="#00529A" stroke-width="2"/>
    <path d="M28.0526 52.9824H53.6667" stroke="#00529A" stroke-width="2"/>
    <path d="M28 60H54" stroke="#00529A" stroke-width="2"/>
  </svg>
</template>